const TYPE_PRODUCT = 1;
const TYPE_DONATION = 2;
const TYPE_EVENT = 3;

export {
    TYPE_PRODUCT,
    TYPE_DONATION,
    TYPE_EVENT
}



// WEBPACK FOOTER //
// ./app/components/shop/js/basket-item-types.js